import React from "react";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import SpinnerButton from "../../components/Button";

function ReopenTicketModal({ toggle, handleReopenClick, handleSubmitMessage }) {
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <div>
        <ModalHeader style={{ fontSize: "1.2rem" }} toggle={toggle}>
          <div style={{ fontSize: "1.2rem" }}>Gracias por el feedback, ¿Queres reabrir el ticket? </div>
        </ModalHeader>
        <ModalFooter>
          <div className="mb-0 px-3 w-100 d-flex justify-content-between">
            <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <div style={{ width: "40%", display: "flex", justifyContent: "space-between" }}>
              <SpinnerButton className="btn btn-danger" type="button" onClick={handleSubmitMessage}>
                No
              </SpinnerButton>
              <SpinnerButton className="btn .btn-success" type="button" onClick={handleReopenClick}>
                Si
              </SpinnerButton>
            </div>
          </div>
        </ModalFooter>
      </div>
    </Modal>
  );
}

export default ReopenTicketModal;
